<template lang="pug">
.page
    a-spin(:spinning="loading")
        a-tabs(v-if="products.length" v-model="activeKey")
            a-tab-pane(v-for="p in products" :key="p.product" :tab="p.product")
                ProductTab(:product="p.product"
                    :myStrategyName="p.strategyName"
                    :meId="meId"
                    :indexCloses="indexCloses")
        a-empty(v-else-if="!loading" description="暂无授权产品")
</template>

<script>
import ProductTab from './ProductTab.vue';

export default {
    components: { ProductTab },
    data() {
        return {
            loading: false,
            products: [],
            activeKey: '',
            indexCloses: [],
        };
    },
    computed: {
        meId() {
            const me = this.$store.state.user.me;
            return me ? me._id : '';
        },
    },
    mounted() {
        this.getProducts();
        this.getIndexCloses();
    },
    methods: {
        getProducts() {
            this.loading = true;
            this.$api.request('GET', 'myProductPerms')
                .then(res => {
                    this.products = res.data;
                    if (this.products.length) this.activeKey = this.products[0].product;
                    this.loading = false;
                })
                .catch(() => { this.loading = false; });
        },
        getIndexCloses() {
            this.$api.request('GET', 'indexKline/000852.XSHG')
                .then(res => { this.indexCloses = res.data; })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    padding: 10px;
}
</style>
